module.exports = __webpack_public_path__ + "img/company_caseten.b67383a8.svg";